var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component, Fragment, createRef } from 'react';
import InputAdapter from '../InputAdapter';
import PropTypes from 'prop-types';
import Icon from '../../Icon';
import DelayVisibility from '../DelayVisibility';

export var Input = function (_Component) {
  _inherits(Input, _Component);

  function Input() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Input);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Input.__proto__ || Object.getPrototypeOf(Input)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isFocusing: false
    }, _this.inputRef = createRef(), _this._handleFocus = function (event) {
      var onFocus = _this.props.onFocus;

      _this.setState({
        isFocusing: true
      });

      onFocus && onFocus(event);
    }, _this._handleBlur = function (event) {
      var onBlur = _this.props.onBlur;


      _this.setState({
        isFocusing: false
      });

      onBlur && onBlur(event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Input, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        if (_this2.props.autoFocus && _this2.inputRef.current) {
          _this2.inputRef.current.focus();
        }
      }, 1);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          required = _props.required,
          description = _props.description,
          className = _props.className,
          value = _props.value,
          errortext = _props.errortext,
          _props$showErrorText = _props.showErrorText,
          showErrorText = _props$showErrorText === undefined ? true : _props$showErrorText,
          _props$showErrorIcon = _props.showErrorIcon,
          showErrorIcon = _props$showErrorIcon === undefined ? false : _props$showErrorIcon,
          others = _objectWithoutProperties(_props, ['label', 'required', 'description', 'className', 'value', 'errortext', 'showErrorText', 'showErrorIcon']);

      var isFocusing = this.state.isFocusing;

      var hasValue = !!value;

      return React.createElement(
        'div',
        {
          className: 'tg_input ' + (isFocusing ? 'input_focus' : '') + ' ' + (hasValue ? 'tg_input_value' : '') + ' ' + (errortext ? 'error' : '') + ' ' + (className ? className : '') + ' ' + (label ? 'has_title' : '') },
        React.createElement(
          'div',
          { className: 'input-wrapper' },
          React.createElement('input', _extends({
            ref: this.inputRef,
            value: value
          }, others, {
            onFocus: this._handleFocus,
            onBlur: this._handleBlur,
            required: required
          })),
          label && React.createElement(
            'div',
            { className: 'input_title' },
            label + ' ' + (required ? '*' : '')
          ),
          showErrorIcon && React.createElement(
            DelayVisibility,
            null,
            React.createElement(
              'div',
              { className: 'error-icon' },
              React.createElement(Icon, { icon: 'exclamation-triangle' })
            )
          )
        ),
        showErrorText && React.createElement(
          Fragment,
          null,
          React.createElement('div', { className: 'bottom-line' }),
          errortext && React.createElement(
            'div',
            { className: 'error-message' },
            errortext
          ),
          !errortext && description && React.createElement(
            'div',
            { className: 'input_description' },
            description
          )
        )
      );
    }
  }]);

  return Input;
}(Component);

Input.propTypes = {
  /** The value type of the field */
  type: PropTypes.string,
  /** Represents the label for each input field */
  label: PropTypes.string,
  /** The validation error message */
  errortext: PropTypes.string,
  /** Name associated with each input field */
  name: PropTypes.string,
  /** Regex pattern for validation of input */
  pattern: PropTypes.string,
  /** Disabled is decided whether an account ID is sent in or not OR on a bool value */
  disabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /** Minimal amount of characters required */
  min: PropTypes.string,
  /** Boolean props deciding whether a field is required to have a value or not */
  required: PropTypes.bool,
  /** Optional description text */
  description: PropTypes.string,
  /** Placeholder text used on the input */
  placeholder: PropTypes.string,
  /** Classnames that should be used on the input */
  className: PropTypes.string,
  /** value of the field */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Function for handling focus on input field  */
  onFocus: PropTypes.func,
  /** Function for when focus is lost from input field */
  onBlur: PropTypes.func,
  /** Listens on value changes */
  onChange: PropTypes.func
};

export default InputAdapter(Input);